// src/pages/Home.tsx
import {
  IonAvatar,
  IonButton,
  IonCard,
  IonCardContent,
  IonCardHeader,
  IonCardTitle,
  IonCol,
  IonContent,
  IonGrid,
  IonHeader,
  IonIcon,
  IonInput,
  IonItem,
  IonLabel,
  IonList,
  IonPage,
  IonRow,
  IonText,
  IonTitle,
  IonToolbar
} from '@ionic/react';
import { checkmarkCircle, closeCircle, document, documentTextOutline, hourglass, informationCircle, receiptOutline } from 'ionicons/icons';
import React, { useCallback, useRef, useState, useEffect } from 'react';
import { enviaXmlValida } from '../../../Utils/Services';
import './Valida.css';

const Valida: React.FC = () => {
  const [dados, setDados] = useState<any>(null);
  const [itens, setItens] = useState<any[]>([]);
  const [files, setFiles] = useState<File[]>([]);
  const [status, setStatus] = useState<any>("");
  const [numeroPedido, setNumeroPedido] = useState<any>("1");
  const [numeroPedidoEnviado, setNumeroPedidoEnviado] = useState<any>("");
  const [statusSucesso, setStatusSucesso] = useState<any>(undefined);
  const [detalhes, setDetalhes] = useState<any>(null);

  const handleFileChange = async (event: React.ChangeEvent<HTMLInputElement>) => {
    const selected = event.target.files ? Array.from(event.target.files) : [];
    setFiles(selected);
    if (selected.length > 0) await filehandle(selected);
  };

  const listXMLItems = async (file: any) => {
    const xmlText = await file.text();
    const parser = new DOMParser();
    const xmlDoc = parser.parseFromString(xmlText, 'application/xml');

    const infNFe = xmlDoc.querySelector('infNFe');
    const signatureValue = xmlDoc.querySelector('SignatureValue')?.textContent;
    const x509Cert = xmlDoc.querySelector('X509Certificate')?.textContent;

    //const output = document.getElementById('output');

    if (!infNFe || !signatureValue || !x509Cert) {
      console.error('❌ Elementos necessários não encontrados no XML.');
      return;
    }
    else {
      console.info('✅ Elementos necessários encontrados no XML.');
    }

    // Canonicalizar o XML (versão simplificada usando XMLSerializer)
    const serializedInfNFe = new XMLSerializer().serializeToString(infNFe);
    const encoder = new TextEncoder();
    const data = encoder.encode(serializedInfNFe);

    const ide = xmlDoc.querySelector('ide');
    const emit = xmlDoc.querySelector('emit');
    const dest = xmlDoc.querySelector('dest');
    const cobr = xmlDoc.querySelector('cobr');
    const infAdic = xmlDoc.querySelector('infAdic');
    const compra = xmlDoc.querySelector('compra');

    const numero = ide?.querySelector('nNF')?.textContent || 'Não encontrado';
    const dataEmissao = ide?.querySelector('dhEmi')?.textContent || 'Não encontrada';
    const dataEmissaoTratada = new Date(new Date(dataEmissao).setHours(0, 0, 0, 0));
    const dataEmissaoTratadaTexto = dataEmissaoTratada.toLocaleDateString();
    const emitente = emit?.querySelector('xNome')?.textContent || 'Não encontrado';
    const emitenteCNPJ = emit?.querySelector('CNPJ')?.textContent || 'Não encontrado';
    //console.log("Emitente CNPJ:", emitenteCNPJ);
    const emitenteCNPJFormatado = emitenteCNPJ.replace(/^(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})$/, "$1.$2.$3/$4-$5");
    //console.log("Emitente CNPJ formatado:", emitenteCNPJFormatado);
    //const destinatario = dest?.querySelector('xNome')?.textContent + " - CNPJ: " + (dest?.querySelector('CNPJ')?.textContent || 'Não encontrado');
    const destinatarioCNPJ = dest?.querySelector('CNPJ')?.textContent || 'Não encontrado';
    //console.log("Destinatário CNPJ:", destinatarioCNPJ);
    const destinatarioCNPJFormatado = destinatarioCNPJ.replace(/^(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})$/, "$1.$2.$3/$4-$5");
    //console.log("Destinatário CNPJ formatado:", destinatarioCNPJFormatado);
    //const destinatario = dest?.querySelector('xNome')?.textContent + " - CNPJ: " + destinatarioCNPJFormatado;
    const destinatario = dest?.querySelector('xNome')?.textContent || 'Não encontrado';

    const cobrDup = cobr?.querySelector('dup');
    const dVenc = cobrDup?.querySelector('dVenc')?.textContent || 'Não encontrado';
    const dVencTratada = new Date(dVenc + 'T00:00:00');
    const dVencTratadaTexto = dVencTratada.toLocaleDateString();
    const diasPagamento = ((dVencTratada.getTime() - dataEmissaoTratada.getTime()) / (1000 * 3600 * 24)).toFixed(0);

    const infAdicInfAdFisco = infAdic?.querySelector('infAdFisco')?.textContent || 'Não encontrado';
    const infAdicInfCpl = infAdic?.querySelector('infCpl')?.textContent || 'Não encontrado';
    const compraXPed = compra?.querySelector('xPed')?.textContent || '';
    const compraXCont = compra?.querySelector('xCont')?.textContent || 'Não encontrado';

    const itensXml = xmlDoc.querySelectorAll('det');
    const listaItens: any[] = [];
    itensXml.forEach((item, index) => {
      const prod = item.querySelector('prod');
      const nome = prod?.querySelector('xProd')?.textContent || 'Sem nome';
      const cProd = prod?.querySelector('cProd')?.textContent || 'Sem código';
      const cEAN = prod?.querySelector('cEAN')?.textContent || 'Sem código';
      const quantidade = Number(prod?.querySelector('qCom')?.textContent || '0');
      const valorUnitario = Number(prod?.querySelector('vUnCom')?.textContent || '0.00');
      const total = (valorUnitario * quantidade).toFixed(2);

      listaItens.push({
        index: index + 1,
        nome,
        cProd,
        cEAN,
        quantidade,
        valorUnitario,
        total,
      });
    });

    return { listaItens: listaItens, numero: numero, compraXPed: compraXPed };
  }

  const filehandle = async (file: any[], zeraLista: boolean = true) => {
    console.log("Processando o arquivo localmente...");
    if (!file || file.length === 0) return;


    // Extrair chave pública do certificado
    //const publicKey = crypto.createPublicKey(certPem);

    const xmlText = await file[0].text();
    const parser = new DOMParser();
    const xmlDoc = parser.parseFromString(xmlText, 'application/xml');

    const infNFe = xmlDoc.querySelector('infNFe');
    const signatureValue = xmlDoc.querySelector('SignatureValue')?.textContent;
    const x509Cert = xmlDoc.querySelector('X509Certificate')?.textContent;

    //const output = document.getElementById('output');

    if (!infNFe || !signatureValue || !x509Cert) {
      console.error('❌ Elementos necessários não encontrados no XML.');
      return;
    }
    else {
      console.info('✅ Elementos necessários encontrados no XML.');
    }

    // Canonicalizar o XML (versão simplificada usando XMLSerializer)
    const serializedInfNFe = new XMLSerializer().serializeToString(infNFe);
    const encoder = new TextEncoder();
    const data = encoder.encode(serializedInfNFe);

    const ide = xmlDoc.querySelector('ide');
    const emit = xmlDoc.querySelector('emit');
    const dest = xmlDoc.querySelector('dest');
    const cobr = xmlDoc.querySelector('cobr');
    const infAdic = xmlDoc.querySelector('infAdic');
    const compra = xmlDoc.querySelector('compra');

    let numero = ide?.querySelector('nNF')?.textContent || 'Não encontrado';
    const dataEmissao = ide?.querySelector('dhEmi')?.textContent || 'Não encontrada';
    const dataEmissaoTratada = new Date(new Date(dataEmissao).setHours(0, 0, 0, 0));
    const dataEmissaoTratadaTexto = dataEmissaoTratada.toLocaleDateString();
    const emitente = emit?.querySelector('xNome')?.textContent || 'Não encontrado';
    const emitenteCNPJ = emit?.querySelector('CNPJ')?.textContent || 'Não encontrado';
    //console.log("Emitente CNPJ:", emitenteCNPJ);
    const emitenteCNPJFormatado = emitenteCNPJ.replace(/^(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})$/, "$1.$2.$3/$4-$5");
    //console.log("Emitente CNPJ formatado:", emitenteCNPJFormatado);
    //const destinatario = dest?.querySelector('xNome')?.textContent + " - CNPJ: " + (dest?.querySelector('CNPJ')?.textContent || 'Não encontrado');
    const destinatarioCNPJ = dest?.querySelector('CNPJ')?.textContent || 'Não encontrado';
    //console.log("Destinatário CNPJ:", destinatarioCNPJ);
    const destinatarioCNPJFormatado = destinatarioCNPJ.replace(/^(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})$/, "$1.$2.$3/$4-$5");
    //console.log("Destinatário CNPJ formatado:", destinatarioCNPJFormatado);
    //const destinatario = dest?.querySelector('xNome')?.textContent + " - CNPJ: " + destinatarioCNPJFormatado;
    const destinatario = dest?.querySelector('xNome')?.textContent || 'Não encontrado';

    const cobrDup = cobr?.querySelector('dup');
    const dVenc = cobrDup?.querySelector('dVenc')?.textContent || 'Não encontrado';
    const dVencTratada = new Date(dVenc + 'T00:00:00');
    const dVencTratadaTexto = dVencTratada.toLocaleDateString();
    const diasPagamento = ((dVencTratada.getTime() - dataEmissaoTratada.getTime()) / (1000 * 3600 * 24)).toFixed(0);

    const infAdicInfAdFisco = infAdic?.querySelector('infAdFisco')?.textContent || 'Não encontrado';
    const infAdicInfCpl = infAdic?.querySelector('infCpl')?.textContent || 'Não encontrado';
    let compraXPed = compra?.querySelector('xPed')?.textContent || '';
    const compraXCont = compra?.querySelector('xCont')?.textContent || 'Não encontrado';

    const itensXml = xmlDoc.querySelectorAll('det');
    const listaItens: any[] = zeraLista ? [] : [...itens];
    itensXml.forEach((item, index) => {
      const prod = item.querySelector('prod');
      const nome = prod?.querySelector('xProd')?.textContent || 'Sem nome';
      const cProd = prod?.querySelector('cProd')?.textContent || 'Sem código';
      const cEAN = prod?.querySelector('cEAN')?.textContent || 'Sem código';
      const quantidade = Number(prod?.querySelector('qCom')?.textContent || '0');
      const quantidadeTributada = Number(prod?.querySelector('qTrib')?.textContent || '0');
      const valorUnitario = Number(prod?.querySelector('vUnCom')?.textContent || '0.00');
      const total = (valorUnitario * quantidade).toFixed(2);

      listaItens.push({
        index: index + 1,
        nome,
        cProd,
        cEAN,
        quantidade,
        quantidadeTributada,
        valorUnitario,
        total,
      });
    });

    for (let i = 1; i < file.length; i++) {
      const itensAdicionais = await listXMLItems(file[i]) || null;
      listaItens.push(...itensAdicionais?.listaItens || []);
      numero = numero + ", " + itensAdicionais?.numero;
      compraXPed = compraXPed + ", " + itensAdicionais?.compraXPed;
    }

    setDados({
      numero,
      dataEmissao,
      dataEmissaoTratadaTexto,
      emitente,
      emitenteCNPJ,
      destinatario,
      destinatarioCNPJ,
      dVenc,
      dVencTratadaTexto,
      diasPagamento,
      infAdicInfAdFisco,
      infAdicInfCpl,
      compraXPed,
      compraXCont,
    });

    //setNumeroPedido((infAdicInfAdFisco + " - " + infAdicInfCpl + " - " + compraXPed + " - " + compraXCont).match(/(?:pedido|Pedido|PEDIDO|ref|Ref)(.)?(:)?\s*(\d+)/g)?.join().match(/\d+/g)?.[0]);
    /*
    let regex = /\b5\d{5}\b/g;
    setNumeroPedido((infAdicInfAdFisco + " - " + infAdicInfCpl + " - " + compraXPed + " - " + compraXCont).match(regex)?.join().match(/\d+/g)?.[0]);
    */
    //console.log("Número do pedido extraído:", (infAdicInfAdFisco + " - " + infAdicInfCpl + " - " + compraXPed + " - " + compraXCont).match(/(?:pedido|Pedido|PEDIDO|ref|Ref)(.)?(:)?\s*(\d+)/g)?.join().match(/\d+/g)?.[0]);
    setNumeroPedido(compraXPed);
    setItens(listaItens);
  }

  const fileInputRef = useRef<HTMLInputElement>(null);
  const numeroPedidoRef = useRef<any>(null);

  const handleFileChange1 = async (event: React.ChangeEvent<HTMLInputElement>) => {
    const selected = event.target.files ? Array.from(event.target.files) : [];
    if (selected.length > 0) console.log('Selected files:', selected.map(f => f.name));
    setFiles(selected);
    if (selected.length > 0) await filehandle([selected[0]]);
  };

  useEffect(() => {
    if (files.length > 0) {
      // garante que o input foi renderizado antes de focar
      setTimeout(() => {
        (numeroPedidoRef.current as any)?.setFocus?.();
      }, 80);
    }
  }, [files.length]);

  const openFileDialog = () => {
    fileInputRef.current?.click();
  };

  const handleFileChange2 = async (event: React.ChangeEvent<HTMLInputElement>) => {
    const selected = event.target.files ? Array.from(event.target.files) : [];
    if (selected.length > 0) {

      if (files.length > 0) {
        filehandle(selected, false);
      }
      else {
        filehandle(selected, true);
      }

      setFiles([...files, ...selected]);
    }

    // Não processa todos os arquivos aqui, apenas armazena e processa o primeiro para compatibilidade
  };

  const handleUpload = async () => {
    if (files.length === 0) {
      //alert("Selecione um arquivo XML primeiro.");
      return;
    }

    function fileToBase64(file: Blob) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onload = () => resolve((typeof reader?.result == 'string') ? reader?.result?.split(",")[1] : "");
        reader.onerror = reject;
        reader.readAsDataURL(file);
      });
    }

    //const base64: any[] = []

    const base64Promises = files.map(async file => {
      return { arquivo: await fileToBase64(file) };
    });

    // Aguarda a resolução de todas as Promises
    const base64 = await Promise.all(base64Promises);

    //files.forEach(async file => {
    //  base64.push({ arquivo: await fileToBase64(file) });
    //});
    //const base64 = await fileToBase64(files[0]);

    let varBody = JSON.stringify({
      arquivo: base64,
      pedido: numeroPedido?.replace(/[-/|;]/g, ',')
    }, null);

    try {
      setStatus("Validando...");
      const response = await fetch(enviaXmlValida.url, {
        method: enviaXmlValida.method,
        headers: {
          "content-type": "application/json",
        },
        body: varBody
      });

      setNumeroPedidoEnviado(numeroPedido);

      const result = await response.json();
      console.log("Success:", result);
      setStatus(result.message);
      setStatusSucesso(result.sucesso);
      setDetalhes(result.detalhes);

      await filehandle(files);
      /*
      // Sucesso: processa o XML localmente e exibe os dados
      if (result.sucesso || result.success === true || result.status === 'success') {
        await filehandle(file);
      } else {
        setDados(null);
        setItens([]);
      }
        */
    } catch (error) {
      console.error(error);
      setStatus("Erro ao enviar o arquivo.");
      setDados(null);
      setItens([]);
    }
  };

  //const [file, setFile] = useState<File | null>(null);
  const [dragActive, setDragActive] = useState(false);

  const handleDrop = useCallback((e: any) => {
    e.preventDefault();
    e.stopPropagation();
    setDragActive(false);
    if (e.dataTransfer.files && e.dataTransfer.files.length) {
      const dropped = Array.from(e.dataTransfer.files as FileList);
      setFiles(dropped);
      if (dropped.length > 0) filehandle([dropped[0]]);
    }
  }, []);

  const handleDragOver = (e: any) => {
    e.preventDefault();
    e.stopPropagation();
    setDragActive(true);
  };

  const handleDragLeave = (e: any) => {
    e.preventDefault();
    e.stopPropagation();
    setDragActive(false);
  };

  const handleFileSelect = (e: any) => {
    if (e.target.files && e.target.files.length) {
      const selected = Array.from(e.target.files as FileList);
      setFiles(selected);
    }
  };

  const handleClear = () => {
    if (fileInputRef.current) {
      fileInputRef.current.value = ""; // reset file input
    }
    setFiles([]); // clear state too
  };

  return (
    <IonPage placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
      <IonHeader placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>

        <IonToolbar color="primary" placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>

          <IonAvatar slot='start' style={{ marginLeft: '10px', width: '48px', height: '48px' }} placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
            <img src={window.localStorage.getItem("logo") ? "/assets/logos/" + window.localStorage.getItem("logo") + ".png" : "/assets/logos/saidamax.png"} />
          </IonAvatar>
          <IonTitle style={{ paddingLeft: '12px' }} placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>Saidamax | Valida <IonIcon slot="icon-only" icon={checkmarkCircle} placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined} /></IonTitle>

        </IonToolbar>
      </IonHeader>
      <IonContent className="ion-padding" placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>


        {status === "" && (
          <>
            {files.length === 0 && (
              <IonCard placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}
                onDrop={handleDrop}
                onDragOver={handleDragOver}
                onDragLeave={handleDragLeave}
                className={`border-2 border-dashed ${dragActive ? "border-blue-600" : "border-gray-400"
                  }`}
                style={{
                  padding: "100px",
                  textAlign: "center",
                  cursor: "pointer",
                  minHeight: "300px"
                }}
              >
                <IonCardContent placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
                  <p>{dragActive ? "Solte o arquivo aqui" : "Arraste e solte um arquivo"}</p>
                  <input
                    type="file"
                    onChange={handleFileChange2}
                    ref={fileInputRef}
                    style={{ marginTop: "20px" }}
                  />
                </IonCardContent>
              </IonCard>
            )}


            <input
              type="file"
              id="file-upload"
              style={{ display: 'none' }} // Hide the default input
              onChange={handleFileChange2}
              ref={fileInputRef}
              multiple={true}
            />
            <IonButton hidden={true} onClick={openFileDialog} placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
              <IonIcon slot="icon-only" icon={document} placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}></IonIcon>
              &nbsp;Selecionar XML da Nota Fiscal
            </IonButton>
            {files.length > 0 && (
              <>

                <IonCard placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}

                  className={`border-2 border-dashed ${dragActive ? "border-blue-600" : "border-gray-400"
                    }`}
                  style={{
                    padding: "40px",
                    textAlign: "center",
                    cursor: "pointer",
                    minHeight: "300px"
                  }}
                >
                  <IonCardContent placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "center",

                      }}
                    >
                      <div
                        style={{
                          fontSize: "14px",
                          color: "#666",
                          marginBottom: "6px",
                        }}
                      >
                        Informe o Número do Pedido
                      </div>
                      <IonInput
                        ref={numeroPedidoRef}
                        value={numeroPedido}
                        onIonChange={(e) => setNumeroPedido(e.detail.value!?.replace(/[-/|;]/g, ','))}
                        onKeyDown={(e: any) => {
                          const key = e?.key || (e?.detail && e.detail.key);
                          if (key === 'Enter') {
                            e.preventDefault?.();
                            handleUpload();
                          }
                        }}
                        placeholder="Digite o número do pedido"
                        style={{
                          maxWidth: "300px",
                          textAlign: "center",
                          fontSize: "18px",
                          marginBottom: "20px",
                          borderBottom: "1px solid #ccc",
                        }} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined} />

                      <IonButton color="secondary" onClick={handleUpload} placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
                        Validar
                      </IonButton>
                    </div>
                  </IonCardContent>
                </IonCard>
                {files.length > 0 && (
                  <div style={{
                    paddingTop: "0px",
                    marginTop: "0px",
                    marginLeft: "15px",
                    minHeight: "10px",
                    height: "20px",
                    display: "flex",
                    alignItems: "center",
                    gap: "8px",
                    fontFamily: 'var(--ion-font-family, inherit)',
                    fontSize: 'var(--ion-font-size, 14px)',
                    color: 'var(--ion-text-color, #666)',
                    fontWeight: 'var(--ion-font-weight, 400)'
                  }}>
                    Arquivo selecionado: {files.map(f => f.name).join(', ')}
                    <IonButton size="small" style={{ fontSize: "10px" }} fill='clear' onClick={() => {
                      handleClear();
                    }} placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
                      <IonIcon slot="icon-only" icon={closeCircle} color="danger" placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}></IonIcon>
                    </IonButton>
                  </div>
                )}




                <IonText hidden={true} color="primary" style={{ display: 'block', marginTop: 8 }} placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
                  Arquivo selecionado: <strong>{files[0]?.name}</strong>
                </IonText>
                <IonItem hidden={true} style={{ marginTop: 8 }} placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
                  <IonLabel position="stacked" placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>Número do Pedido</IonLabel>
                  <IonInput value={numeroPedido} onIonChange={e => { setNumeroPedido(e.detail.value!?.replace(/[-/|;]/g, ',')) }} placeholder="Digite o número do pedido" onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined} />
                </IonItem>
                <IonButton hidden={true} size="small" color="medium" style={{ marginTop: 4, marginLeft: 8 }} onClick={() => {
                  setFiles([]);
                  if (fileInputRef.current) fileInputRef.current.value = "";
                }} placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
                  Limpar arquivo
                </IonButton>
              </>
            )}
            {files.length > 0 && (
              <IonButton hidden={true} color="secondary" style={{ marginTop: 12 }} onClick={handleUpload} placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
                Validar
              </IonButton>
            )}
          </>
        )}
        <div hidden={true} style={{ display: "flex", justifyContent: "end" }}>
          {status !== "" && (
            <IonButton
              color="secondary"
              onClick={() => {
                setStatus("");
                setFiles([]);
                if (fileInputRef.current) fileInputRef.current.value = "";
              }}
              placeholder={undefined}
              onPointerEnterCapture={undefined}
              onPointerLeaveCapture={undefined}
            >
              Nova Validação
            </IonButton>
          )}
        </div>

        <IonItem hidden={true} placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
          <IonLabel position="stacked" placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>Selecione o arquivo XML</IonLabel>
          <IonInput onIonChange={(e: any) => handleFileChange} placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined} />
        </IonItem>

        {dados && status !== "" && (
          <>
            <IonCard id='cardum' placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
              <IonCardContent placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
                <IonGrid placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
                  <IonRow placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>

                    <IonCol size='12' style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }} placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
                      <div style={{ textAlign: 'center', width: '100%' }}>
                        <IonIcon icon={statusSucesso == undefined ? hourglass : statusSucesso ? checkmarkCircle : closeCircle} color={statusSucesso == undefined ? 'gray' : statusSucesso ? 'success' : 'danger'} style={{ fontSize: '80px' }} placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined} />
                        <div style={{ marginTop: '8px' }}>
                          <h1 style={{ margin: 0 }}>{status}</h1>
                          <p style={{ margin: '6px 0' }}>{statusSucesso == undefined ? "" : statusSucesso ? 'Nota liberada para recebimento pelo cliente' : 'Entre em contato com o Comprador'}</p>
                          <IonButton
                            color="secondary"
                            onClick={() => {
                              setStatus("");
                              setStatusSucesso(undefined);
                              setFiles([]);
                              if (fileInputRef.current) fileInputRef.current.value = "";
                            }}
                            placeholder={undefined}
                            onPointerEnterCapture={undefined}
                            onPointerLeaveCapture={undefined}
                          >
                            Nova Validação
                          </IonButton>
                        </div>
                      </div>
                    </IonCol>

                  </IonRow>
                </IonGrid>
              </IonCardContent>
            </IonCard>


            <div hidden={(statusSucesso == undefined ? true : false || status == "Pedido não encontrado")}>

              <div style={{ display: 'flex', padding: '30px', paddingBottom: '5px', justifyContent: 'center', fontWeight: 'bold' }}>Resumo da Validação</div>



              <IonCard hidden={false} placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>

                <IonCardContent placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>

                  <IonGrid hidden={false} style={{ border: '1px solid #ccc!important', minWidth: '300px', maxWidth: '500px' }} placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
                    <IonRow placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
                      <IonCol size='6' placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
                        <IonList placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
                          <IonItem style={{ margin: 0, padding: 0, height: 'fit-content', '--min-height': '10px' }} placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
                            <IonLabel style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', margin: '5px' }} placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}><IonIcon icon={receiptOutline} slot="start" placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}></IonIcon>&nbsp;Notas</IonLabel>
                          </IonItem>
                          <IonItem style={{ margin: 0, padding: 0, height: 'fit-content', '--min-height': '10px' }} lines='none' placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
                            <IonLabel class="ion-text-wrap" style={{ textAlign: 'center', margin: '5px' }} placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>{dados?.numero || '—'}</IonLabel>
                          </IonItem>
                        </IonList>
                      </IonCol>

                      <IonCol size='6' placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
                        <IonList placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
                          <IonItem style={{ margin: 0, padding: 0, height: 'fit-content', '--min-height': '10px' }} placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
                            <IonLabel style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', margin: '5px' }} placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}><IonIcon icon={documentTextOutline} slot="start" placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}></IonIcon>&nbsp;Pedidos</IonLabel>
                          </IonItem>
                          <IonItem style={{ margin: 0, padding: 0, height: 'fit-content', '--min-height': '10px' }} lines='none' placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
                            <IonLabel className="ion-text-wrap" style={{ textAlign: 'center', margin: '5px' }} placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>{numeroPedidoEnviado || '—'}</IonLabel>
                          </IonItem>
                        </IonList>


                      </IonCol>
                    </IonRow>
                  </IonGrid>



                  <IonList placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>

                    <IonItem placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
                      <IonIcon slot='start' icon={(detalhes?.notaDadosNota == undefined || detalhes?.notaDadosNota?.sucesso) ? checkmarkCircle : closeCircle} color={(detalhes?.notaDadosNota == undefined || detalhes?.notaDadosNota?.sucesso) ? 'success' : 'danger'} size='large' placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined} />
                      <IonLabel placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>Dados da Nota</IonLabel>
                    </IonItem>

                    <IonItem placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
                      <IonIcon slot='start' icon={((detalhes?.notaCobranca == undefined || detalhes?.notaCobranca?.sucesso) && detalhes?.notaCobranca?.validacao.length !== 0) ? informationCircle : (detalhes?.notaCobranca == undefined || detalhes?.notaCobranca?.sucesso) ? checkmarkCircle : closeCircle} color={((detalhes?.notaCobranca == undefined || detalhes?.notaCobranca?.sucesso) && detalhes?.notaCobranca?.validacao.length !== 0) ? 'primary' : (detalhes?.notaCobranca == undefined || detalhes?.notaCobranca?.sucesso) ? 'success' : 'danger'} size='large' placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined} />
                      <IonLabel placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>Cobrança</IonLabel>
                    </IonItem>

                    <IonItem placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
                      <IonIcon slot='start' icon={checkmarkCircle} color='success' size='large' placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined} />
                      <IonLabel placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>Informações Adicionais</IonLabel>
                    </IonItem>

                    <IonItem placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
                      <IonIcon slot='start' icon={(detalhes?.notaItens == undefined || detalhes?.notaItens?.sucesso || Object.keys(detalhes?.notaItens).length === 0) ? checkmarkCircle : closeCircle} color={(detalhes?.notaItens == undefined || detalhes?.notaItens?.sucesso || Object.keys(detalhes?.notaItens).length === 0) ? 'success' : 'danger'} size='large' placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined} />
                      <IonLabel placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>Itens da Nota Fiscal</IonLabel>
                    </IonItem>

                    {detalhes?.notaItens?.itensNoPedidoNaoEncontradosNoXML?.length > 0 && (
                      <>
                        <IonItem placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
                          <IonIcon slot='start' icon={informationCircle} color={'primary'} size='large' placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined} />
                          <IonLabel placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>Itens do Pedido não encotrados na Nota Fiscal <b>(apenas informativo)</b></IonLabel>
                        </IonItem>
                      </>)}
                  </IonList>
                </IonCardContent>

              </IonCard>

              <div style={{ display: 'flex', padding: '30px', justifyContent: 'center', fontWeight: 'bold' }}>Detalhes da Validação</div>

              <IonCard className="card-com-faixa-verde card-com-faixa-cinza" placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
                {/* 
                <div className={"faixa-verde faixa-cinza"}>
                  <IonIcon icon={hourglass} className="faixa-verde-icone" placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined} />
                </div>
                */}
                <div className="card-content-col">
                  <IonCardHeader style={{ marginBottom: '10px' }} color={(detalhes?.notaDadosNota == undefined || detalhes?.notaDadosNota?.sucesso) ? 'success' : 'danger'} placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
                    <IonCardTitle className="header-itens-nota-align" placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
                      <IonIcon icon={(detalhes?.notaDadosNota == undefined || detalhes?.notaDadosNota?.sucesso) ? checkmarkCircle : closeCircle} className="faixa-verde-icone" placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined} />
                      Dados da Nota
                    </IonCardTitle>
                  </IonCardHeader>
                  <IonCardContent placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
                    <IonGrid className="grid-com-borda" placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
                      <IonRow className="row-titulos" placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
                        <IonCol class='col-centralizada header-bold' size='3' placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>Item</IonCol>
                        <IonCol class='col-centralizada header-bold' placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>XML</IonCol>
                        <IonCol class='col-centralizada header-bold' size='1' placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>Valida</IonCol>

                      </IonRow>

                      <IonRow placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
                        <IonCol size='3' placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>Número</IonCol>
                        <IonCol placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>{dados.numero}</IonCol>
                        <IonCol class='col-centralizada icon-size' size='1' placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}><IonIcon icon={checkmarkCircle} color='success' placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined} /></IonCol>

                      </IonRow>
                      <IonRow placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
                        <IonCol size='3' placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>Data de Emissão</IonCol>
                        <IonCol placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>{dados.dataEmissao}</IonCol>
                        <IonCol class='col-centralizada icon-size' size='1' placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}><IonIcon icon={checkmarkCircle} color='success' placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined} /></IonCol>

                      </IonRow>
                      <IonRow placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
                        <IonCol size='3' placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>Emitente</IonCol>
                        <IonCol placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>{dados.emitente}</IonCol>
                        <IonCol class='col-centralizada icon-size' size='1' placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}></IonCol>

                      </IonRow>
                      <IonRow placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
                        <IonCol size='3' placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>Emitente CNPJ</IonCol>
                        <IonCol placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>{dados.emitenteCNPJ}</IonCol>
                        <IonCol class='col-centralizada icon-size' size='1' placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}><IonIcon icon={detalhes?.notaDadosNota?.camposComErro.includes("cnpjEmit") ? closeCircle : checkmarkCircle} color={detalhes?.notaDadosNota?.camposComErro.includes("cnpjEmit") ? 'danger' : 'success'} placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined} /></IonCol>

                      </IonRow>
                      <IonRow hidden={(detalhes?.notaDadosNota?.camposComErro.includes("cnpjEmit")) ? false : true} style={{ borderWidth: "0 0 1px 0", borderStyle: "solid", borderColor: "lightgrey" }} placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
                        <IonCol style={{ color: "red", fontWeight: "bold" }} size='12' placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>CNPJ do emissor da nota diferente do pedido</IonCol>
                      </IonRow>
                      <IonRow placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
                        <IonCol size='3' placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>Destinatário</IonCol>
                        <IonCol placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>{dados.destinatario}</IonCol>
                        <IonCol class='col-centralizada icon-size' size='1' placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}></IonCol>

                      </IonRow>
                      <IonRow placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
                        <IonCol size='3' placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>Destinatário CNPJ</IonCol>
                        <IonCol placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>{dados.destinatarioCNPJ}</IonCol>
                        <IonCol class='col-centralizada icon-size' size='1' placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}><IonIcon icon={detalhes?.notaDadosNota?.camposComErro.includes("cnpjDest") ? closeCircle : checkmarkCircle} color={detalhes?.notaDadosNota?.camposComErro.includes("cnpjDest") ? 'danger' : 'success'} placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined} /></IonCol>

                      </IonRow>
                      <IonRow hidden={(detalhes?.notaDadosNota?.camposComErro.includes("cnpjDest")) ? false : true} style={{ borderWidth: "0 0 1px 0", borderStyle: "solid", borderColor: "lightgrey" }} placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
                        <IonCol style={{ color: "red", fontWeight: "bold" }} size='12' placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>Loja não encontrada no pedido</IonCol>
                      </IonRow>
                    </IonGrid>
                  </IonCardContent>
                </div>
              </IonCard>

              <IonCard className="card-com-faixa-verde card-com-faixa-vermelha" placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>

                <div className="card-content-col">
                  <IonCardHeader style={{ marginBottom: '10px' }} color={((detalhes?.notaCobranca == undefined || detalhes?.notaCobranca?.sucesso) && detalhes?.notaCobranca?.validacao.length !== 0) ? 'primary' : (detalhes?.notaCobranca == undefined || detalhes?.notaCobranca?.sucesso) ? 'success' : 'danger'} placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
                    <IonCardTitle className="header-itens-nota-align" placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
                      <IonIcon icon={((detalhes?.notaCobranca == undefined || detalhes?.notaCobranca?.sucesso) && detalhes?.notaCobranca?.validacao.length !== 0) ? informationCircle : (detalhes?.notaCobranca == undefined || detalhes?.notaCobranca?.sucesso) ? checkmarkCircle : closeCircle} className="faixa-verde-icone" placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined} />
                      Cobrança
                    </IonCardTitle>
                  </IonCardHeader>
                  <IonCardContent placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
                    <IonGrid className="grid-com-borda" placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
                      <IonRow className="row-titulos" placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
                        <IonCol class='col-centralizada header-bold' size='3' placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>Item</IonCol>
                        <IonCol class='col-centralizada header-bold' placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>XML</IonCol>
                        <IonCol class='col-centralizada header-bold' size='1' placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>Valida</IonCol>
                      </IonRow>

                      <IonRow placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
                        <IonCol size='3' placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>Vencimento</IonCol>
                        <IonCol placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>{dados.dVenc}</IonCol>
                        <IonCol class='col-centralizada icon-size' size='1' placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}><IonIcon icon={((detalhes?.notaCobranca == undefined || detalhes?.notaCobranca?.sucesso) && detalhes?.notaCobranca?.validacao.length !== 0) ? informationCircle : (detalhes?.notaCobranca == undefined || detalhes?.notaCobranca?.sucesso) ? checkmarkCircle : closeCircle} color={((detalhes?.notaCobranca == undefined || detalhes?.notaCobranca?.sucesso) && detalhes?.notaCobranca?.validacao.length !== 0) ? 'primary' : (detalhes?.notaCobranca == undefined || detalhes?.notaCobranca?.sucesso) ? 'success' : 'danger'} placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined} /></IonCol>
                      </IonRow>

                      <IonRow hidden={((detalhes?.notaCobranca == undefined || detalhes?.notaCobranca?.sucesso) && detalhes?.notaCobranca?.validacao.length === 0) ? true : false} style={{ borderWidth: "0 0 1px 0", borderStyle: "solid", borderColor: "lightgrey" }} placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
                        <IonCol style={{ color: "red", fontWeight: "bold" }} size='12' placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>{detalhes?.notaCobranca?.validacao.join(", ") || ""}</IonCol>
                      </IonRow>
                    </IonGrid>
                  </IonCardContent>
                </div>
              </IonCard>

              <IonCard className="card-com-faixa-verde" placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
                {/* 
                <div className="faixa-verde">
                  <IonIcon icon={checkmarkCircle} className="faixa-verde-icone" placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined} />
                </div>
                */}
                <div className="card-content-col">
                  <IonCardHeader style={{ marginBottom: '10px' }} color='success' placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
                    <IonCardTitle className="header-itens-nota-align" placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
                      <IonIcon icon={checkmarkCircle} className="faixa-verde-icone" placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined} />
                      Informações Adicionais
                    </IonCardTitle>
                  </IonCardHeader>
                  <IonCardContent placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
                    <IonGrid className="grid-com-borda" placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
                      <IonRow className="row-titulos" placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
                        <IonCol class='col-centralizada header-bold' placeholder={undefined} size='3' onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>Item</IonCol>
                        <IonCol class='col-centralizada header-bold' placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>XML</IonCol>
                        <IonCol class='col-centralizada header-bold' size='1' placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>Valida</IonCol>

                      </IonRow>
                      <IonRow placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
                        <IonCol placeholder={undefined} size='3' onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>Fisco</IonCol>
                        <IonCol placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>{dados.infAdicInfAdFisco}</IonCol>
                        <IonCol class='col-centralizada icon-size' size='1' placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}><IonIcon icon={checkmarkCircle} color='success' placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined} /></IonCol>

                      </IonRow>
                      <IonRow placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
                        <IonCol placeholder={undefined} size='3' onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>Complementares</IonCol>
                        <IonCol placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>{dados.infAdicInfCpl}</IonCol>
                        <IonCol class='col-centralizada icon-size' size='1' placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}><IonIcon icon={checkmarkCircle} color='success' placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined} /></IonCol>

                      </IonRow>
                      <IonRow placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
                        <IonCol placeholder={undefined} size='3' onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>Pedido</IonCol>
                        <IonCol placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>{dados.compraXPed}</IonCol>
                        <IonCol class='col-centralizada icon-size' size='1' placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}><IonIcon icon={checkmarkCircle} color='success' placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined} /></IonCol>

                      </IonRow>
                      <IonRow placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
                        <IonCol placeholder={undefined} size='3' onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>Contrato</IonCol>
                        <IonCol placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>{dados.compraXCont}</IonCol>
                        <IonCol class='col-centralizada icon-size' size='1' placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}><IonIcon icon={checkmarkCircle} color='success' placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined} /></IonCol>

                      </IonRow>
                    </IonGrid>
                  </IonCardContent>
                </div>
              </IonCard>

              <IonCard className="card-com-faixa-verde" placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
                <div className="card-content-col">
                  <IonCardHeader style={{ marginBottom: '10px' }} color={(detalhes?.notaItens == undefined || detalhes?.notaItens?.sucesso || Object.keys(detalhes?.notaItens).length === 0) ? 'success' : 'danger'} placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
                    <IonCardTitle className="header-itens-nota-align" placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
                      <IonIcon icon={(detalhes?.notaItens == undefined || detalhes?.notaItens?.sucesso || Object.keys(detalhes?.notaItens).length === 0) ? checkmarkCircle : closeCircle} className="faixa-verde-icone" placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined} />
                      Itens da Nota
                    </IonCardTitle>
                  </IonCardHeader>
                  <IonCardContent placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
                    <IonGrid className="grid-com-borda" placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
                      <IonRow className="row-titulos" placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
                        <IonCol class='col-centralizada header-bold' size='1' placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>#</IonCol>
                        <IonCol class='col-centralizada header-bold' size='3' placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>ITEM</IonCol>
                        <IonCol class='col-centralizada header-bold' size='2' placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>GTIN</IonCol>
                        <IonCol class='col-centralizada header-bold' size='2' placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>PROD</IonCol>
                        <IonCol class='col-centralizada header-bold' placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>PEDIDO</IonCol>
                        <IonCol class='col-centralizada header-bold' size='1' placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>VALIDA</IonCol>
                      </IonRow>
                      {itens.map((item: any) => {
                        const naoEncontrado = detalhes?.notaItens?.itensNoXMLNaoEncontradosNoPedido?.find((itemNota: any) => itemNota.cEAN == item.cEAN && itemNota.cProd == item.cProd);

                        if (naoEncontrado) {
                          return (
                            <>
                              <IonRow placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
                                <IonCol size='1' placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>{item.index}</IonCol>
                                <IonCol size='3' placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>{item.nome}</IonCol>
                                <IonCol size='2' placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>{item.cEAN}</IonCol>
                                <IonCol size='2' placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>{item.cProd}</IonCol>
                                <IonCol placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>{item.quantidade} un. — R$ {item.valorUnitario} — Total: R$ {item.total}</IonCol>
                                <IonCol class='col-centralizada icon-size' size='1'
                                  placeholder={undefined} onPointerEnterCapture={undefined}
                                  onPointerLeaveCapture={undefined}>
                                  <IonIcon icon={naoEncontrado ? closeCircle : checkmarkCircle} color={naoEncontrado ? 'danger' : 'success'} placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined} /></IonCol>
                              </IonRow>
                              <IonRow style={{ borderWidth: "0 0 1px 0", borderStyle: "solid", borderColor: "lightgrey" }} placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
                                <IonCol size='1' placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}></IonCol>
                                <IonCol style={{ color: "red", fontWeight: "bold" }} size='11' placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>{naoEncontrado?.validacao || ""}</IonCol>
                              </IonRow>
                            </>

                          );
                        }
                        else {
                          const encontrado = detalhes?.notaItens?.itensNoXMLEncontrados?.find((itemNota: any) => itemNota.cEAN == item.cEAN);
                          if (encontrado?.sucesso != undefined && encontrado?.sucesso) {
                            return (
                              <IonRow style={{ borderWidth: "0 0 1px 0", borderStyle: "solid", borderColor: "lightgrey" }} placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
                                <IonCol size='1' placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>{item.index}</IonCol>
                                <IonCol size='3' placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>{item.nome}</IonCol>
                                <IonCol size='2' placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>{item.cEAN}</IonCol>
                                <IonCol size='2' placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>{item.cProd}</IonCol>
                                <IonCol placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>{item.quantidade} un. — R$ {item.valorUnitario} — Total: R$ {item.total}</IonCol>
                                <IonCol class='col-centralizada icon-size' size='1'
                                  placeholder={undefined} onPointerEnterCapture={undefined}
                                  onPointerLeaveCapture={undefined}>
                                  <IonIcon icon={checkmarkCircle} color={'success'} placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined} /></IonCol>
                              </IonRow>
                            );
                          }
                          else {
                            return (
                              <>
                                <IonRow placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
                                  <IonCol size='1' placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>{item.index}</IonCol>
                                  <IonCol size='3' placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>{item.nome}</IonCol>
                                  <IonCol size='2' placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>{item.cEAN}</IonCol>
                                  <IonCol size='2' placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>{item.cProd}</IonCol>
                                  <IonCol placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>{item.quantidade} un. — R$ {item.valorUnitario} — Total: R$ {item.total}</IonCol>
                                  <IonCol class='col-centralizada icon-size' size='1'
                                    placeholder={undefined} onPointerEnterCapture={undefined}
                                    onPointerLeaveCapture={undefined}>
                                    <IonIcon icon={closeCircle} color={'danger'} placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined} /></IonCol>
                                </IonRow>
                                <IonRow style={{ borderWidth: "0 0 1px 0", borderStyle: "solid", borderColor: "lightgrey" }} placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
                                  <IonCol size='1' placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}></IonCol>
                                  <IonCol style={{ color: "red", fontWeight: "bold" }} size='11' placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>{encontrado?.validacao.join(", ") || ""}</IonCol>
                                </IonRow>
                              </>
                            );
                          }
                        }
                      })}
                      {/*
                      {itens.map((item: any) => (
                        { detalhes?.notaItens?.itensNoXMLNaoEncontradosNoPedido?.some((itemNota: any) => itemNota.cEAN == item.cEAN).sucesso ?
                          (
                            <IonRow placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
                              <IonCol size='1' placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>{item.index}</IonCol>
                              <IonCol size='4' placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>{item.nome}</IonCol>
                              <IonCol size='2' placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>{item.cEAN}</IonCol>
                              <IonCol placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>{item.quantidade} un. — R$ {item.valorUnitario} — Total: R$ {item.total}</IonCol>
                              <IonCol class='col-centralizada icon-size' size='1'
                                placeholder={undefined} onPointerEnterCapture={undefined}
                                onPointerLeaveCapture={undefined}>
                                <IonIcon icon={detalhes?.notaItens?.itensNoXMLNaoEncontradosNoPedido?.some((itemNota: any) => itemNota.cEAN == item.cEAN) ? closeCircle : checkmarkCircle} color={detalhes?.notaItens?.itensNoXMLNaoEncontradosNoPedido?.some((itemNota: any) => itemNota.cEAN == item.cEAN) ? 'danger' : 'success'} placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined} /></IonCol>
                            </IonRow>
                          )
                          :
                          (
                            <>
                            <IonRow placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
                              <IonCol size='1' placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>{item.index}</IonCol>
                              <IonCol size='4' placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>{item.nome}</IonCol>
                              <IonCol size='2' placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>{item.cEAN}</IonCol>
                              <IonCol placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>{item.quantidade} un. — R$ {item.valorUnitario} — Total: R$ {item.total}</IonCol>
                              <IonCol class='col-centralizada icon-size' size='1'
                                placeholder={undefined} onPointerEnterCapture={undefined}
                                onPointerLeaveCapture={undefined}>
                                <IonIcon icon={detalhes?.notaItens?.itensNoXMLNaoEncontradosNoPedido?.some((itemNota: any) => itemNota.cEAN == item.cEAN) ? closeCircle : checkmarkCircle} color={detalhes?.notaItens?.itensNoXMLNaoEncontradosNoPedido?.some((itemNota: any) => itemNota.cEAN == item.cEAN) ? 'danger' : 'success'} placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined} /></IonCol>
                            </IonRow>
                            <IonRow style={{ background: "red" }} placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
                              <IonCol size='1' placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}></IonCol>
                              <IonCol size='11' placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>{(detalhes?.notaItens?.itensNoXMLNaoEncontradosNoPedido?.find((itemNota: any) => itemNota.cEAN == item.cEAN))?.validacao || ""}</IonCol>
                            </IonRow>
                            </>
                          )
                        }
                      ))}
                        */}
                    </IonGrid>
                  </IonCardContent>
                </div>
              </IonCard>

              {detalhes?.notaItens?.itensNoPedidoNaoEncontradosNoXML?.length > 0 && (
                <>
                  <IonCard className="card-com-faixa-verde" placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
                    <div className="card-content-col">
                      <IonCardHeader style={{ marginBottom: '10px' }} color={'primary'} placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
                        <IonCardTitle className="header-itens-nota-align" placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
                          <IonIcon icon={informationCircle} className="faixa-verde-icone" placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined} />
                          Itens do Pedido não encontrados na Nota Fiscal
                        </IonCardTitle>
                      </IonCardHeader>
                      <IonCardContent placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>

                        <IonGrid className="grid-com-borda" placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
                          <IonRow className="row-titulos" placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
                            <IonCol class='col-centralizada header-bold' size='1' placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>#</IonCol>
                            <IonCol class='col-centralizada header-bold' size='3' placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>ITEM</IonCol>
                            <IonCol class='col-centralizada header-bold' size='2' placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>GTIN</IonCol>
                            <IonCol class='col-centralizada header-bold' size='2' placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>PROD</IonCol>
                            <IonCol class='col-centralizada header-bold' placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>PEDIDO</IonCol>
                            <IonCol class='col-centralizada header-bold' size='1' placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>VALIDA</IonCol>
                          </IonRow>

                          {detalhes?.notaItens?.itensNoPedidoNaoEncontradosNoXML?.map((item: any, index: any) => (

                            <IonRow style={{ borderWidth: "0 0 1px 0", borderStyle: "solid", borderColor: "lightgrey" }} placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
                              <IonCol size='1' placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>{index + 1}</IonCol>
                              <IonCol size='3' placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>{item.xProd}</IonCol>
                              <IonCol size='2' placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>{item.cEAN}</IonCol>
                              <IonCol size='2' placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>{item.cProd}</IonCol>
                              <IonCol placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>{item.qCom} un. — R$ {item.vUnCom} — Total: R$ {item.vProd}</IonCol>
                              <IonCol class='col-centralizada icon-size' size='1'
                                placeholder={undefined} onPointerEnterCapture={undefined}
                                onPointerLeaveCapture={undefined}>
                                <IonIcon icon={informationCircle} color={'primary'} placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined} /></IonCol>
                            </IonRow>

                          ))}
                        </IonGrid>
                      </IonCardContent>
                    </div>
                  </IonCard>
                </>
              )}
            </div>
          </>
        )}
      </IonContent>
    </IonPage >
  );
};

export default Valida;